import { render, staticRenderFns } from "./bookingApp.vue?vue&type=template&id=0648ec3f&"
import script from "./bookingApp.vue?vue&type=script&lang=js&"
export * from "./bookingApp.vue?vue&type=script&lang=js&"
import style0 from "./bookingApp.vue?vue&type=style&index=0&id=0648ec3f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports